import React, { useState, useEffect } from 'react';
import './Carousel.css'; // Add your external CSS file here


import Table1 from '../../assets/image/50KSET.jpg'
import Table2 from '../../assets/image/1.png'
import Table3 from '../../assets/image/2.png'
import Table4 from '../../assets/image/3.png'
import Table5 from '../../assets/image/table4.jpg'
import Table6 from '../../assets/image/7.png'
import Table7 from '../../assets/image/8.png'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';


const bashUrl = process.env.REACT_APP_BASH_URL;
const imgUrl = process.env.REACT_APP_BASH_IMG_URL;

const Carousel = () => {

    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)

    const getBanners = async () => {
        return await axios.get(`${bashUrl}/carousels`).then((response) => {
            setItems(response.data.result)
            setLoading(false)
        }).catch((error) => {
            console.log("error on getBanners: ", error);
            setLoading(false)
        })
    }

    useEffect(() => {
        getBanners()
    }, [loading])

    const navigate = useNavigate()
    const [currentIndex, setCurrentIndex] = useState(0);
    const timeAutoNext = 7000;
    const timeRunning = 3000;

    useEffect(() => {
        const runNextAuto = setTimeout(() => {
            nextSlide();
        }, timeAutoNext);

        return () => clearTimeout(runNextAuto);
    }, [currentIndex]);

    const nextSlide = () => {
        setItems(prevItems => [...prevItems.slice(1), prevItems[0]]);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    };

    const prevSlide = () => {
        setItems(prevItems => [prevItems[prevItems.length - 1], ...prevItems.slice(0, prevItems.length - 1)]);
        setCurrentIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
    };

    /* const resetTimeAnimation = () => {
        document.querySelector('.timeRunning').style.animation = 'none'
        document.querySelector('.timeRunning').offsetHeight; // Trigger reflow
        document.querySelector('.timeRunning').style.animation = null;
        document.querySelector('.timeRunning').style.animation = `runningTime ${timeAutoNext / 1000}s linear forwards`;
    }; */
    const resetTimeAnimation = () => {
        const timeRunningElement = document.querySelector('.timeRunning');

        if (timeRunningElement) {
            timeRunningElement.style.animation = 'none';
            void timeRunningElement.offsetHeight; // Trigger reflow, avoid lint error
            timeRunningElement.style.animation = null;
            timeRunningElement.style.animation = `runningTime ${timeAutoNext / 1000}s linear forwards`;
        }
    };

    useEffect(() => {
        resetTimeAnimation();
    }, [currentIndex]);

    return (
        <div className="carousel">
            <div className="list">
                {items.map((item, idx) => (
                    <div key={item?._id} className={`item ${idx === currentIndex ? 'active' : ''}`} style={{ backgroundImage: `url(${item?.image})` }}>
                        <div className="content">
                            <div className="title">{item?.title}</div>
                            <div className="name">{item?.name}</div>
                            <div className="des">{item?.description}</div>
                            <div className="btn">
                                <button onClick={() => navigate('/Products')}>See More</button>
                                <button>Subscribe</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="arrows">
                <button className="prev" onClick={prevSlide}>
                    &lt;
                </button>
                <button className="next" onClick={nextSlide}>
                    &gt;
                </button>
            </div>

            <div className="timeRunning"></div>
        </div>
    );
};

export default Carousel;
